module.exports = function getResource(label, vars = []) {
    let resources = {
        changeStore: 'Change Store',
        viewDetails: 'View details',
        getDirections: 'Get directions',
        findASephora: 'Find a Sephora',
        happeningAtSephora: 'Happening at Sephora',
        viewAll: 'View all',
        openUntil: `Open until ${vars[0]}`,
        closed: 'Closed',
        noStoreNear: `We were not able to find a store near “${vars[0]}”.`,
        useStore: 'Use This Store',
        chooseThisStore: 'Choose This Store',
        chooseYourStore: 'Choose Your Store',
        reservationNotOffered: 'Reservation not offered',
        milesAway: ' miles away',
        ok: 'OK',
        changeStoreMessage: 'The pickup location will be updated to',
        changeStoreMessage2: 'for all pickup items',
        anyPromosRewardsMsg: 'Any promos or rewards in your pickup basket will also be removed. You may add promos and rewards in store, if available.'
    };

    return resources[label];
};
